export interface Experience {
  id: string;
  title: string;
  company: string;
  location?: string;
  startDate: string;
  endDate: string | 'Present';
  description: string[];
  technologies?: string[];
}

export const experiences: Experience[] = [
  {
    id: 'tesla-intern',
    title: 'Incoming Software Engineer Intern, Vehicle Software: Robotaxi',
    company: 'Tesla',
    location: 'Palo Alto, CA',
    startDate: 'August 2026',
    endDate: 'December 2026',
    description: [],
    technologies: [],
  },
  {
    id: 'microsoft-intern',
    title: 'Software Engineer Intern',
    company: 'Microsoft',
    location: 'Redmond, WA',
    startDate: 'May 2026',
    endDate: 'August 2026',
    description: [
      'Shipped conflict detection, notification, and AI-assisted resolution for Outlook Calendar AI across C#/.NET, React/TypeScript, and agent orchestration, handling 39K calendar-rule conflicts per month',
      'Reduced production false conflict classifications by 71%, eliminating an estimated 28K incorrect conflicts per month',
      'Fixed a production notification-lifecycle bug in a 99K messages per month processing path, preventing dismissed and snoozed alerts from resurfacing through safe reconciliation, bounded state reads, and telemetry',
      'Rebuilt Calendar AI conflict resolution in Office Agent with native agent tools; migrated a 32-case benchmark',
    ],
    technologies: ['C#', '.NET', 'React', 'TypeScript', 'AI Agents'],
  },
  {
    id: 'amazon-intern',
    title: 'Software Engineer Intern',
    company: 'Amazon',
    location: 'New York, NY',
    startDate: 'February 2026',
    endDate: 'April 2026',
    description: [
      'Extended authorization infrastructure across 41K+ applications and 198K+ service relationships to secure agentic AI with a Python hook-based runtime enforcement layer',
      'Designed a deterministic policy engine to track cumulative risk and block unsafe multi-step tool combinations',
      'Built Java backend on AWS Lambda exposing 12 tools via MCP, integrating with OAuth-based authorization',
      'Validated the agent across 4 attack scenarios, demonstrating human approval and end-to-end MCP-to-auth flows',
    ],
    technologies: ['Python', 'Java', 'AWS Lambda', 'MCP', 'OAuth'],
  },
  {
    id: 'capital-one-intern',
    title: 'Software Engineer Intern',
    company: 'Capital One',
    location: 'McLean, VA',
    startDate: 'June 2025',
    endDate: 'August 2025',
    description: [
      'Built automated LLM evaluation pipeline in Python/Snowflake scaling model validation from dozens to 10K+ queries per deployment, reducing engineering time from days of manual review to overnight batch processing',
      'Trained ensemble classifiers with scikit-learn (Random Forest, XGBoost) and developed NLP scoring system (ROUGE, Levenshtein, fuzzy encoding) achieving 91.2% accuracy in deployment verification',
      'Engineered backtesting framework to validate metric/classifier updates against all previous evaluation runs',
    ],
    technologies: ['Python', 'Snowflake', 'Scikit-Learn'],
  },
  {
    id: 'umd-ml-researcher',
    title: 'Research Engineer | Advisors: Dr. Furong Huang, Dr. Zikui Cai',
    company: 'University of Maryland',
    location: 'College Park, MD',
    startDate: 'September 2025',
    endDate: 'Present',
    description: [
      'Built Python, Slurm, and Bash HPC data pipeline for editable-slide VLM training, scaling Zenodo corpus from 10,448 to 18,044 PPTX decks and processing 451K slides into PPTX/schema/PNG triplets across 16 parallel shards',
      'Developed PPTX-to-schema compiler for editable VLM slide reconstruction, cutting tokens 46% with 95.1% fidelity',
      'Architected PyTorch and LLaMA-Factory pipeline to fine-tune Qwen3.5-4B VLM with LoRA SFT, training 16.2M params and implementing evals for object IoU/F1, CLIP/DINO, SSIM, and LPIPS',
    ],
    technologies: ['Python', 'Slurm', 'Bash', 'PyTorch', 'LLaMA-Factory', 'HPC'],
  },
  {
    id: 'umd-ta',
    title: 'Teaching Assistant, CMSC330 (Programming Languages)',
    company: 'University of Maryland',
    location: 'College Park, MD',
    startDate: 'January 2025',
    endDate: 'January 2026',
    description: [
      'Maintained 7 OCaml/Rust projects with 90+ tests for 900+ students; deployed via GitHub Actions and Docker',
      'Led weekly discussion for 30+ students, hosted 5+ weekly office hours, and coordinated grading with 39 TAs',
    ],
    technologies: ['OCaml', 'Rust', 'Docker', 'GitHub Actions', 'Git'],
  },
  {
    id: 'wise-cities-intern',
    title: 'Software Engineer Intern',
    company: 'WISE Cities',
    location: 'College Park, MD',
    startDate: 'February 2025',
    endDate: 'May 2025',
    description: [
      'Led backend development of a recommendation system for older adults to find local organizations and activities',
      'Engineered scalable gRPC microservice with MongoDB querying and Pydantic data validation',
      'Integrated all-MiniLM-L6-v2 and Pinecone to enable sub-100ms k-NN recommendations',
    ],
    technologies: ['Python', 'gRPC', 'MongoDB', 'Pydantic', 'Pinecone'],
  },
  {
    id: 'usda-intern',
    title: 'Technology Intern',
    company: 'USDA',
    location: 'Riverdale, MD',
    startDate: 'June 2024',
    endDate: 'August 2024',
    description: [
      'Automated inbox processing with Power Automate and Microsoft Lists; reduced team\'s manual load by 70%',
      'Directed accessibility testing across 142 web apps for Section 508 compliance',
      'Built Python tool for USDA document lifecycle validation using Pandas, reducing processing time by 80%',
    ],
    technologies: ['Python', 'Pandas', 'Power Automate', 'Microsoft Lists'],
  },
];
